export default "/_next/static/fonts/Honey-ExtraboldBanner-88240800eb5734510bf3e313c420196e.woff2";